import { render, staticRenderFns } from "./language-selection.vue?vue&type=template&id=75dd1ed1&"
import script from "./language-selection.vue?vue&type=script&lang=js&"
export * from "./language-selection.vue?vue&type=script&lang=js&"
import style0 from "./language-selection.vue?vue&type=style&index=0&id=75dd1ed1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports